module.exports = "<form [formGroup]=\"datePickerRangeForm\">\r\n  <my-date-range-picker\r\n    formControlName=\"dateRange\"\r\n    [options]=\"myDatePickerOptions\">\r\n  </my-date-range-picker>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/date-range-available-update-so/date-range-available-update-so.component.html
// module id = 2591
// module chunks = 66